"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var mousetrap_1 = __importDefault(require("mousetrap"));
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
function getSequencesFromMap(hotKeyMap, hotKeyName) {
    var sequences = hotKeyMap[hotKeyName];
    var result = [];
    if (!sequences) {
        return [hotKeyName];
    }
    return result.concat(sequences);
}
var HotKeys = (function (_super) {
    __extends(HotKeys, _super);
    function HotKeys(props) {
        var _this = _super.call(this, props) || this;
        _this.wrappedComponent = react_1.default.createRef();
        _this.focus = function (preLocation) {
            if (_this.wrappedComponent.current) {
                _this.wrappedComponent.current.focus();
                if (_this.props.onNavigateIn) {
                    _this.props.onNavigateIn(preLocation);
                }
            }
        };
        _this.navigateTo = function (target) {
            var to = function (next) {
                var targetComponent = _this.hotKeyChain.find(function (instance) {
                    var dom = instance.wrappedComponent.current;
                    if (dom) {
                        var style = window.getComputedStyle(dom);
                        return instance.name === next && style.visibility !== 'hidden';
                    }
                    return false;
                });
                if (targetComponent) {
                    targetComponent.focus(_this.props.name);
                    return true;
                }
                return false;
            };
            if (target) {
                if (_this.props.onNavigateOut) {
                    _this.props.onNavigateOut();
                }
                if (typeof target === 'string') {
                    to(target);
                }
                else {
                    target.some(function (t) { return to(t); });
                }
            }
        };
        _this.onFocus = function (e) {
            if (_this.props.onFocus) {
                _this.props.onFocus(e);
            }
            if (e.target === _this.wrappedComponent.current) {
                _this.setFocus();
            }
        };
        _this.name = props.name;
        _this.focusOnMount = !!props.focusOnMount;
        return _this;
    }
    HotKeys.prototype.getChildContext = function () {
        return {
            hotKeyParent: this,
            hotKeyMap: this.hotKeyMap,
        };
    };
    HotKeys.prototype.componentWillMount = function () {
        this.updateMap();
        if (this.context.hotKeyParent) {
            this.hotKeyChain = this.context.hotKeyParent.hotKeyChain;
            this.hotKeyChain.push(this);
        }
        else {
            this.hotKeyChain = [this];
        }
    };
    HotKeys.prototype.componentDidMount = function () {
        if (this.wrappedComponent.current) {
            this.mousetrap = new mousetrap_1.default(this.wrappedComponent.current);
        }
        this.updateHotKeys(true);
        this.mounted = true;
        var lastNodeInChain;
        if (this.hotKeyChain) {
            lastNodeInChain = this.hotKeyChain[this.hotKeyChain.length - 1];
        }
        if (this.props.focusOnMount && this === lastNodeInChain && this.wrappedComponent.current) {
            this.wrappedComponent.current.focus();
        }
    };
    HotKeys.prototype.setFocus = function () {
        this.hotKeyChain.forEach(function (h) {
            if (h.focused) {
                h.focused = false;
                h.previousFocused = true;
            }
            else if (h.previousFocused) {
                h.previousFocused = false;
            }
        });
        this.focused = true;
        this.previousFocused = false;
    };
    HotKeys.prototype.componentDidUpdate = function (prevProps) {
        this.updateHotKeys(false, prevProps);
    };
    HotKeys.prototype.componentWillUnmount = function () {
        var _this = this;
        if (this.mousetrap) {
            this.mousetrap.reset();
        }
        this.mounted = false;
        if (this.hotKeyChain) {
            this.hotKeyChain.splice(this.hotKeyChain.indexOf(this), 1);
        }
        setTimeout(function () {
            var _a;
            var focusUpdated = false;
            _this.hotKeyChain.forEach(function (h) {
                var _a;
                if (h.previousFocused) {
                    focusUpdated = true;
                    (_a = h.wrappedComponent.current) === null || _a === void 0 ? void 0 : _a.focus();
                }
            });
            if (!focusUpdated && _this.hotKeyChain.length > 0) {
                (_a = _this.hotKeyChain[_this.hotKeyChain.length - 1].wrappedComponent.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
        });
    };
    HotKeys.prototype.buildMap = function () {
        var parentMap = this.context.hotKeyMap || {};
        var thisMap = this.props.keyMap || {};
        return __assign(__assign({}, parentMap), thisMap);
    };
    HotKeys.prototype.updateMap = function () {
        var newMap = this.buildMap();
        if (!lodash_isequal_1.default(newMap, this.hotKeyMap)) {
            this.hotKeyMap = newMap;
            return true;
        }
        return false;
    };
    HotKeys.prototype.updateHotKeys = function (force, prevProps) {
        var _this = this;
        if (force === void 0) { force = false; }
        var handlers = this.props.handlers || {};
        var navigator = this.props.navigator || {};
        var prevHandlers = (prevProps && prevProps.handlers) || handlers;
        if (!force && lodash_isequal_1.default(handlers, prevHandlers) && !this.updateMap()) {
            return;
        }
        var allSequenceHandlers = [];
        Object.keys(handlers)
            .concat(Object.keys(navigator))
            .forEach(function (hotKey) {
            var sequences = getSequencesFromMap(_this.hotKeyMap, hotKey);
            var handler = handlers[hotKey];
            var navigatorHandler = navigator[hotKey];
            var sequenceHandlers = sequences.map(function (seq) {
                var combo, eventType, callback;
                if (typeof seq === 'string' || Array.isArray(seq)) {
                    combo = seq;
                }
                else if (seq) {
                    combo = seq.combo;
                    eventType = seq.eventType;
                }
                else {
                    return;
                }
                if (!navigatorHandler) {
                    callback = handler;
                }
                else {
                    callback = function (e, combo) {
                        if (typeof navigatorHandler === 'string' || Array.isArray(navigatorHandler)) {
                            var target = navigatorHandler;
                            _this.navigateTo(target);
                        }
                        else {
                            var target = navigatorHandler(_this);
                            _this.navigateTo(target);
                        }
                        if (handler) {
                            return handler(e, combo);
                        }
                        else {
                            return false;
                        }
                    };
                }
                return { callback: callback, eventType: eventType, combo: combo };
            });
            allSequenceHandlers = allSequenceHandlers.concat(sequenceHandlers);
        });
        this.mousetrap.reset();
        allSequenceHandlers.forEach(function (handler) {
            if (handler) {
                _this.mousetrap.bind(handler.combo, handler.callback, handler.eventType);
            }
        });
    };
    HotKeys.prototype.render = function () {
        var _a = this.props, navigator = _a.navigator, children = _a.children, keyMap = _a.keyMap, handlers = _a.handlers, focusOnMount = _a.focusOnMount, onNavigateIn = _a.onNavigateIn, onNavigateOut = _a.onNavigateOut, onFocus = _a.onFocus, props = __rest(_a, ["navigator", "children", "keyMap", "handlers", "focusOnMount", "onNavigateIn", "onNavigateOut", "onFocus"]);
        return (react_1.default.createElement("div", __assign({}, props, { onFocus: this.onFocus, ref: this.wrappedComponent, tabIndex: -1 }), children));
    };
    HotKeys.contextTypes = {
        hotKeyParent: prop_types_1.default.any,
        hotKeyMap: prop_types_1.default.object,
    };
    HotKeys.childContextTypes = {
        hotKeyParent: prop_types_1.default.any,
        hotKeyMap: prop_types_1.default.object,
    };
    HotKeys.defaultProps = {
        focusOnMount: true,
    };
    return HotKeys;
}(react_1.default.Component));
exports.HotKeys = HotKeys;
exports.default = HotKeys;
//# sourceMappingURL=HotKeys.js.map